/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class RSVPSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-13-et --black-gradient z-22 p-40">
                    <div className="container p-40 relative-text">

                        <div className="row mb0 p-40 ">
                            <div className="col s12 center-align">
                                <h1 className="f-62 white-text text-uppercase">RSVP TO SAVE YOUR SPOT<br/>

                                    <span className="f-100-long ls-5 white-text bold-text">AT Disrupt <span className="f-100-long ls-5 brand-text bold-text">Puerto Rico</span>
                                    </span> </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 center-align">
                                <h1 className="f-32 white-text text-uppercase text-normal">DISRUPT WEEK 2018 Begins<br/><span className="bold-text white-text">October 19th - 26th</span></h1>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <h1 className="f-32 white-text text-uppercase text-normal">The location of the Event is<br/>
                                    <br/>
                                    <span className="bold-text white-text">Piloto 151</span> <br className="hide-on-med-and-down"/>

                                    151 Calle San Francisco<br className="hide-on-med-and-down"/> San Juan,PR 00901


                                </h1>

                                <br/>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 center-align">
                               <CTA/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section m0 oheka-castle-green z-22">

                    <img src="../static/manny-cutout.png" className="responsive-img" alt=""/>

                </div>

            </div>
        )

    }

}

export default RSVPSection;


// WEBPACK FOOTER //
// ./src/components/rsvp-section.js